import React from "react";
import Header from "./Header";
import FiledHub from "../filed/FiledHub";

export default function LayoutFiledHub() {
  return (
    <>
      <Header />
      <FiledHub />
    </>
  );
}
